import type { GridApi } from 'ag-grid-community'
import type { DeliveryReconSiteOverviewRow } from './types'
import type { GridConfigState } from '@gravitate-js/excalibrr/dist/components/GraviGrid/hooks/useAGGridEvent'

import { useDeliveryRecon } from '@/api/useDeliveryReconciliation'
import { useUserSettings } from '@/hooks/settings'
import { GraviButton, GraviGrid, Horizontal } from '@gravitate-js/excalibrr'
import { type MutableRefObject, useRef, useState } from 'react'
import { getColumnDefs } from './columnDefs'
import { DeliveryConfigDrawer } from './components/DeliveryConfigDrawer'
import { SettingOutlined } from '@ant-design/icons'

export function DeliveryConfig() {
  const gridRef = useRef<GridApi>(null)
  const { updateSetting } = useUserSettings()
  const { useSiteOverview, useGetConfig } = useDeliveryRecon()

  const { data: configData, isLoading: isConfigLoading } = useGetConfig()
  const { data, isLoading } = useSiteOverview()

  const [selectedRow, setSelectedRow] = useState<DeliveryReconSiteOverviewRow | null>(null)
  const [open, setOpen] = useState(false)

  function handleOpenConfigDrawer(row?: DeliveryReconSiteOverviewRow) {
    setSelectedRow(row ?? null)
    setOpen(true)
  }

  const columnDefs = getColumnDefs(configData, handleOpenConfigDrawer)
  return (
    <>
      <GraviGrid
        externalRef={gridRef as MutableRefObject<GridApi>}
        controlBarProps={{
          title: 'Delivery Config',
          actionButtons: (
            <Horizontal verticalCenter gap='1em'>
              <GraviButton
                color='primary'
                appearance='outlined'
                icon={<SettingOutlined />}
                onClick={() => handleOpenConfigDrawer()}
              >
                Edit Global Config
              </GraviButton>
            </Horizontal>
          ),
        }}
        columnDefs={columnDefs}
        agPropOverrides={{
          suppressRowClickSelection: true,
          getRowId: (row) => `${row.data.store_id}-${row.data.tank_id}`,
        }}
        rowData={data ?? []}
        storageKey='delivery-config'
        loading={isLoading || isConfigLoading}
        onGridConfigChanged={(config: GridConfigState) => updateSetting('gridConfig::delivery-config', config)}
      />
      <DeliveryConfigDrawer
        open={open}
        configData={configData}
        selectedRow={selectedRow}
        onClose={() => setOpen(false)}
      />
    </>
  )
}
